
<button class="badge nav-link btn-secondary button px-1 float-right ml-3" (click)= 'autoRollAsgnmnt()'> autoRoll CBSE Booster </button>


<button class="badge nav-link btn-secondary button px-1 float-right ml-3" (click)= 'startAutoRoller()'>autoRoll GRE Booster </button>

